export enum NonConformanceActionType {
  Created = 1,
  Edited = 2,
  Delegated = 3,
  Closed = 4,
  Completed = 5,
  Reopened = 6,
  Rejected = 7,
  Signed = 8,
  Restored = 10,
  Deleted = 11,
}
